export default __webpack_public_path__ + "static/media/difficulty.0307b907.svg";